import classNames from 'classnames'
import React from 'react'
import Text from '../../../components/atoms/Text'

const RadioGroup = ({ field, register, watch }) => {
  const value = watch(field.name)
  return (
    <div className="w-full flex flex-col items-start gap-1">
      <Text
        tag="span"
        size="medium"
        variant="label"
        className="text-text-primary"
      >
        {'Gender'}
      </Text>
      <div className="space-y-4 w-full">
        {field.options?.map((item) => (
          <div key={item.label} className="relative">
            <input
              id={item.label}
              type="radio"
              value={item.val}
              {...register(field.name, field.validation)}
              className="peer sr-only"
            />
            <label
              htmlFor={item.label}
              className="flex items-center px-3.5 py-3 rounded-lg gap-2 border cursor-pointer 
                     peer-checked:border-border-accent-indigo-primary peer-checked:bg-background-accent-indigo
                     transition-colors duration-200"
            >
              <div
                className="w-4 h-4 rounded-full flex items-center justify-center
                          peer-checked:border-border-accent-indigo-primary ring-1 peer-checked:ring-border-accent-indigo-primary"
              >
                <div
                  className={classNames(
                    'w-3 h-3 rounded-full peer-checked:bg-foreground-accent-indigo-primary',
                    {
                      'bg-foreground-accent-indigo-primary': value === item.val,
                    },
                  )}
                />
              </div>
              <Text
                tag="p"
                variant="label"
                size="large"
                className="peer-checked:text-text-accent-indigo-primary"
              >
                {item.label}
              </Text>
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RadioGroup
